import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryMultipleFormat extends TitleBase {
	private formatValue: string;

	protected canHandle(): boolean {
		this.formatValue = this.getFilterValue(ParameterType.ATTENDANCE);

		return (
			this.indexableFilters.length === 1 &&
			this.multiValueFilters.length >= 1 &&
			this.indexableFilters.some((_) => _.type === ParameterType.ATTENDANCE) &&
			this.multiValueFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected getPageTitle(): string {
		return `${this.formatValue} ${this.titlePortalType} in selected countries`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.formatValue} ${this.titlePortalType}`, ' in selected countries');
	}
}
